// extracted by mini-css-extract-plugin
export var divider = "_ru-0";
export var systemMessage = "_ru-1";